class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      console.log("loop-cart: CartRemoveButton click event", {
        cartItems,
        index: this.dataset.index,
      });
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        console.log("loop-cart: cartUpdate event", event);
        this.onCartUpdate();
      }
    );
    // Function to toggle active class on click
    document.querySelectorAll(".select-btns").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var parentMenu = this.closest(".select-menus");
        if (parentMenu) {
          parentMenu.classList.toggle("active");

          // Remove active class from siblings of the parentMenu
          var siblings =
            parentMenu.parentNode.querySelectorAll(".select-menus");
          siblings.forEach(function (sibling) {
            if (sibling !== parentMenu) {
              sibling.classList.remove("active");
            }
          });
        }
        console.log("loop-cart: select-btns click event", { parentMenu });
      });
    });

    // Function to handle click on variant items
    document
      .querySelectorAll(".product-variant .variant-li-block")
      .forEach(function (item) {
        item.addEventListener("click", function () {
          // Remove active class from all select-menus
          document.querySelectorAll(".select-menus").forEach(function (menu) {
            menu.classList.remove("active");
          });

          // Update select-btns text
          var title = this.getAttribute("data-variant-label");
          var parentMenu = this.closest(".select-menus");
          parentMenu.querySelector(".select-btns .sBtn-text").textContent =
            title;

          // Update variant id and price
          var vals = this.getAttribute("data-variant-id");
          var parentProductInfo = this.closest(".product_info_wrapper");
          parentProductInfo.querySelector(
            '.cart_button_wrapper input[name="id"]'
          ).value = vals;

          var valsPrice = this.getAttribute("data-variant-price");
          parentProductInfo.querySelector(
            ".cart_button_wrapper .price"
          ).textContent = valsPrice;
          console.log("loop-cart: variant-li-block click event", {
            title,
            vals,
            valsPrice,
          });
        });
      });

    $(".add_cart").click(function () {
      var vals = $(this)
        .parents(".cart_button_wrapper")
        .find('input[name="id"]')
        .val();
      var qty = 1;

      console.log("loop-cart: add_cart click event", { vals, qty });

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: vals,
          quantity: qty,
        },
        dataType: "json",
        success: function () {
          $("cart-drawer").removeClass("is-empty");
          $(".drawer__inner-empty").hide();
          $("cart-drawer").load(location.href + " #CartDrawer");
          $(".cart_item_clear_btn").addClass("active");
          setTimeout(function () {
            $(".cart_item_clear_btn").addClass("active");
            $(".drawer").addClass("active animate");
          }, 1000);

          jQuery.getJSON("/cart.js", function (cart) {
            if (cart.item_count > 0) {
              $(".header__icon .cart-count-bubble span:first-child").text(
                cart.item_count
              );
            }
            // Adding the fetched cart items to window.Loop.bundleCartAllItems
          });
          console.log("loop-cart: add_cart success");
        },
        error: function () {
          console.log("loop-cart: add_cart error");
        },
      });
    });

    var vars = parseInt(window.settings.product_range_price);
    var currnt = $(
      ".cart__contents .drawer__cart-items-wrapper .totals__total-value"
    ).text();
    var matchResult = currnt.match(/\d+\.\d+/);
    if (matchResult !== null) {
      var currnt = parseFloat(matchResult[0]);
    }

    var percentage = (currnt / vars) * 100;
    console.log("loop-cart: progress bar calculation", {
      percentage,
      currnt,
      vars,
    });
    if (percentage >= "100") {
      $(".progress_bar .progress_range_line").css("width", "100%");
    } else {
      $(".progress_bar .progress_range_line").css("width", percentage + "%");
    }
    
    var tot = vars - currnt;
      $(".progress_range_label .price").text(
        '<span class="price">£' + tot.toFixed(2) + "</span>"
      );
    

    if (currnt > vars) {
      $(".complete_progress").show();
      $(".progress_range_label").html("Free Shipping <span>Unlocked!</span>");
    } else {
      $(".complete_progress").hide();
      $(".progress_range_label").html(
        'Just <span class="price">£' +
          tot.toFixed(2) +
          "</span> Away from Free Shipping"
      );
    }

    /* Update bottom checkout price */
    var saving_price = $("cart-drawer-items .cart-disc-amt p").text();
    console.log("loop-cart: saving_price", saving_price);
    if (saving_price >= "£1") {
      $(".drawer .cart-disc-amt").show();
    } else {
      $(".drawer .cart-disc-amt").hide();
    }
    $(".drawer__footer .cart-drawer__footer .cart-disc-amt p").text(
      saving_price
    );
    var tot_price = $("cart-drawer-items .totals__total-value").text();
    $(
      ".drawer__footer .cart-drawer__footer .cart-subtotal-amt .totals__total-value"
    ).text(tot_price);
    var tot_com = $("cart-drawer-items .totals_compare_price").text();
    $(
      ".drawer__footer .cart-drawer__footer .cart-subtotal-amt .totals_compare_price"
    ).text(tot_com);

    var mySwiper = new Swiper(".cart-swiper-container", {
      loop: false,
      slidesPerView: 1.2,
      navigation: {
        nextEl: ".cart--button-next",
        prevEl: ".cart--button-prev",
      },
      paginationClickable: true,
      spaceBetween: 15,
    });

    $(".cart-drawer__collection .product_title").matchHeight({});

    fetch("/cart.js")
      .then((response) => {
        console.log("loop-init: fetch response received");
        if (!response.ok) {
          console.error("loop-init: Network response was not ok");
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("loop-init: data fetched successfully");
        const cart = data;
        window.Loop = {};
        window.Loop.bundleCartAllItems = cart.items;
        console.log("loop-init: calling initLoopBundle from connectedCallback");
        initLoopBundle("drawer-loop");
      })
      .catch((error) => {
        console.error(
          "loop-init: There was a problem with the fetch operation:",
          error
        );
      });

    console.log("loop-cart: connectedCallback executed");
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }

    console.log("loop-cart: disconnectedCallback executed");
  }

  onChange(event) {
    console.log("loop-cart: onChange event", {
      index: event.target.dataset.index,
      value: event.target.value,
    });
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    console.log("loop-cart: onCartUpdate triggered");
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error("loop-cart: Error fetching cart drawer content", e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error("loop-cart: Error fetching main cart items", e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    console.log("loop-cart: updateQuantity called", {
      line,
      quantity,
      name,
      variantId,
    });

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
        // window.Loop = {};
        // window.Loop.bundleCartAllItems = parsedState.items;
        // console.log("loop-cart: called initLoopBundle from updateQuantity");
        // initLoopBundle("drawer-loop");
        console.log("loop-cart: updateQuantity success", parsedState);
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        console.log("loop-cart: updateQuantity error");
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
    console.log("loop-cart: updateLiveRegions", { line, message });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    // this.lineItemStatusElement.setAttribute("aria-hidden", false);
    console.log("loop-cart: enableLoading", {
      lineItemStatusElement: this.lineItemStatusElement,
    });
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", "false");
    } else {
      console.error("loop-cart: lineItemStatusElement is null or undefined");
      // Handle the case where this.lineItemStatusElement is not available
    }
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
    console.log("loop-cart: disableLoading", { line });
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
            console.log("loop-cart: cart-note input event", {
              note: event.target.value,
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Loop Bundle Code

document.addEventListener("loopByobAddToCartSuccessEvent", function (e) {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      updateCartDrawer(cart);
      console.log("loop-cart: loopByobAddToCartSuccessEvent", cart);
    })
    .catch((error) => {
      console.error("loop-cart: Error fetching cart", error);
    });
});

function updateCartDrawer(cart) {
  console.log("loop-cart: updateCartDrawer called", cart);
  fetch("/cart.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(cart),
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    redirect: "follow",
    referrerPolicy: "no-referrer",
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      $.ajax({
        url: "/?section_id=cart-drawer",
        type: "GET",
        dataType: "html",
        success: function (carthtml) {
          $(".cart-drawer").html($(carthtml).find(".cart-drawer").eq(0).html());
          $("cart-drawer").removeClass("is-empty");
          $("cart-drawer").addClass("active");
        },
        error: function (xhr, status, error) {
          console.error("loop-cart: Error fetching cart drawer content", error);
        },
      });
    })
    .catch((error) => {
      console.error("loop-cart: Error adding item to cart", error);
    });
}
